import React, { useState, useCallback, useEffect } from "react";
import CommonFormLabel from "../../components/formLabel";
import Input from "../../components/input";
import { useNavigate } from "react-router-dom";
import ValidationFeedback from "../../components/validationFeedback";
import CommonButton from "../../components/commonButton";
import SimpleDropdown from "../../components/simpleDropdown";
import { useDispatch } from "react-redux";
import { Card, Toast, Form, Col, Row } from "react-bootstrap";
import { Formik } from "formik";
import { addState } from "./stateSlice";
import { stateSchema } from "../../schema/validationSchemas";
import { getCountries } from "../Settings/settingSlice";

export default function Add() {
  const navigate = useNavigate();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countriesOptions, setCountriesOptions] = useState([]);

  const dispatch = useDispatch();

  const initialEventState = {
    name: "",
    country_id: ""
  };

  const handleModalClose = () => {
    setCountriesOptions([]);
    navigate("/states");
  };

  const fetchCountries = useCallback(async () => {
      try {
        await dispatch(getCountries({})).then((res) => {
          if (res.payload) {
            if (res.payload.length > 0) {
              const formattedData = res.payload.map((country) => ({
                value: country.id,
                label: country.name,
              }));
              setCountriesOptions(formattedData);
            }
          } else {
            setCountriesOptions([]);
          }
        });
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    }, [dispatch]);

    useEffect(() => {
        fetchCountries();
      }, [fetchCountries]);

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    setIsSubmitting(true);
    await dispatch(addState(values))
      .then((res) => {
        if (res.payload && res.payload.success) {
          localStorage.setItem("state_notify_message", res.payload.message);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
          navigate("/states");
        } else {
          setErrors(res.payload.data);
          setSnackbarMessage(
            res.payload.message || "Failed to add state!"
          );
          setSnackbarVariant("danger");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setSnackbarMessage("Failed to add state!");
        setSnackbarVariant("danger");
        setShowSnackbar(true);
        setSubmitting(false);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Formik
        initialValues={initialEventState}
        validationSchema={stateSchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          handleChange,
          handleSubmit,
          values,
          setFieldValue,
        }) => (
          <Form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="bg-white p-4 rounded-2 shadow-sm"
          >
            <Card className="bg-white p-4 rounded-2 shadow-sm mb-4">
              <h4 className="mb-4 d-flex justify-content-center">Basic</h4>
              <Row>
              <Col md={6}>
                <CommonFormLabel htmlFor="name" title="Name" />
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter Name"
                  onChange={handleChange}
                  className={`shadow-none ${
                    errors?.name && touched.name
                      ? "error"
                      : "correct"
                  }`}
                />
                {touched.name && errors?.name && (
                  <ValidationFeedback title={errors?.name} />
                )}
              </Col>
              <Col md={6}>
                  <SimpleDropdown
                    label="Country"
                    name="country_id"
                    value={values.country_id}
                    onChange={(selectedOption) => {
                      setFieldValue("country_id", selectedOption.value);
                    }}
                    options={countriesOptions}
                    placeholder="Select a Country"
                    error={errors?.country_id}
                    touched={touched.country_id}
                  />
                </Col>
              </Row>
              
            </Card>

            <div className="d-flex align-items-center justify-content-end gap-3 common-popup-btn">
              <CommonButton
                title={isSubmitting ? "Adding..." : "Add"}
                type="submit"
                disabled={isSubmitting}
                className="btn-primary primary-shadow"
              />
              <CommonButton
                title="Cancel"
                onClick={handleModalClose}
                className="btn-muted"
              />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
